// @ts-nocheck
import React, { useState, useEffect, useMemo, useContext } from 'react';
import Router, { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import PS from '@/services/permission/permission-service';
import Breadcrumbs from '@/components/breadcrumbs';
import Storage from '@/utils/storage';
import { Box, Card, Tabs } from "@mantine/core";
import JobsTable from '@/PageComponents/Table/Component Tables/JobsTable';
import RecurringJobsTable from "@/PageComponents/Table/Component Tables/RecurringJobsTable";
import ProjectsTable from "@/PageComponents/Table/Component Tables/ProjectsTable";
import SCMessageBarContext from '@/utils/contexts/sc-message-bar-context';
import constants from '@/utils/constants';
import tabStyles from '@/styles/Tabs.module.css'
import { createFileRoute } from '@tanstack/react-router'




function JobList() {

    const messageBarContext = useContext(SCMessageBarContext);

    const tabData = useMemo(() => ({
        jobs: {
            label: 'Jobs',
            access: PS.hasPermission(Enums.PermissionName.Job)
        },
        recurringjobs: {
            label: 'Recurring Jobs',
            access: PS.hasPermission(Enums.PermissionName.RecurringJob)
        },
        projects: {
            label: 'Projects',
            access: PS.hasPermission(Enums.PermissionName.Project)
        },
    }), [])


    const router = useRouter()

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    useEffect(() => {
        const tab = router.asPath.split('?tab=')[1]
        if (tab && tabData[tab]) {
            setActiveTab(tab)
        }
    }, []);


    const [activeTab, setActiveTab] = useState<string | null>(Object.entries(tabData).find(([, x]: any) => x.access)?.[0] || 'jobs');

    const handleTabChange = (newTabName: string | null) => {
        setActiveTab(newTabName)
        router.replace(router.asPath.split('?')[0] + '?tab=' + newTabName)
    }

    const tabs = <>
        <Tabs color={'scBlue'} value={activeTab} onChange={handleTabChange}
            classNames={{
                tab: tabStyles.scTab,
                list: tabStyles.scTabList,
                tabLabel: tabStyles.scTabLabel
            }}
        >
            <Tabs.List mb={0} pb={0}>
                {
                    Object.entries(tabData).filter(([, x]: any) => true).map(
                        ([tabName, d]: any) => d &&
                            <Tabs.Tab value={tabName}
                                disabled={!d.access}
                                key={tabName + 'tab'}>
                                {d.label}
                            </Tabs.Tab>
                    )
                }
            </Tabs.List>
        </Tabs>
    </>

    return (
        <>
            <Box
                mt={'var(--mantine-spacing-sm)'}
                px={'var(--mantine-spacing-md)'}
                mb={0}
                pb={0}
                style={(theme: any) => ({ borderBottom: `${theme.colors.gray[2]} 2px solid` })}
            >
                <Box my={'var(--mantine-spacing-md)'}>
                    <Breadcrumbs currPage={{
                        text: tabData[activeTab || '']?.label,
                        link: `/job/list?tab=${activeTab || ''}`,
                        type: 'list'
                    }} />
                </Box>


                {tabs}

            </Box>
            <Box
                mih={`calc(100vh - 135px${((messageBarContext as any)?.isActive ? ` - ${constants.messageBarMargin}px` : "")})`}
                style={(theme: any) => ({
                    backgroundColor: theme.colors.gray[1]
                })}
                p={'var(--mantine-spacing-xs)'}
            >
                <Card
                    style={{
                        backgroundColor: 'white'
                    }}
                    p={'var(--mantine-spacing-md)'}
                    radius={'md'}
                >
                    {
                        activeTab === 'jobs' &&
                        <JobsTable /> ||
                        activeTab === 'recurringjobs' &&
                        <RecurringJobsTable /> ||
                        activeTab === 'projects' &&
                        <ProjectsTable />
                    }
                </Card>

            </Box>

        </>
    )
}

export default JobList;

export const Route = createFileRoute('/_authenticated/job/list')({ component: JobList })
